import React from "react";

import Navbar from "./Component/Home/Navbar";
import { Route, Routes } from "react-router-dom";

// import NotFound from './Component/Home/Home'

import ContactSection from "./Component/Home/Contact";
import InternshipApplication from "./Component/Home/Internship";
import Gallery from "./Component/Home/Gallery";
import BlogPage from "./Component/Home/BlogPage";
import Portfolio from "./Component/Home/CaseStudio";
import MainPage from "./Component/Home/MainPage";
import JobOpenings from "./Component/Home/JobPage";
import Services from "./Component/Home/Services";
import AboutUs from "./Component/About/About";
import TestimonialsPage from "./Component/Home/Testimonial";
import Career from "./Component/Home/Career";
import TeamPage from "./Component/Home/Team";
import ProductCard from "./Component/Home/Product";
import ProductCards from "./ZipCourier";
import Products from "./Component/Home/Product";
import OurWorkVideo from "./Component/Home/OurWorkVideo";
import Work from "./Component/Home/Work";
import Schedule from "./Component/Home/Schedule";
import CTAFooterSection from "./Component/Home/Footer";
import Compiler from "./Component/compiler";
import DSAStudyPlanner from "./Component/Home/DSAStudyPlanner";

const App = () => {
  return (
    <div>
      {/* <Navbar /> */}
      <Routes>
        <Route path="/" element={<DSAStudyPlanner />} />
      </Routes>
      {/* <CTAFooterSection /> */}
    </div>
  );
};

export default App;
